import Splide from '@splidejs/splide';

let context;

class BenefitsBar {

  scrollObserver(benefitElement) {
    let observer;
    let options;

    options = {
      rootMargin: '0px 0px 100px 0px'
    };

    context = this;
    observer = new IntersectionObserver(this.handleIntersect, options);
    this.observer = observer;
    this.observer.observe(benefitElement);
  }

  init(benefitElement) {
    // Set the carousel properties & behavior
    this.benefitsCarousel = new Splide(benefitElement, {
      type: 'loop',
      autoplay: true,
      interval: 3000,
      start: 0,
      focus: 'center',
      perPage: 1,
      pauseOnHover: true,
      updateOnMove: true,
      pagination: false,
      arrows: false,
      padding: false,
      easing: 'linear',
      width: '30rem',
      speed: 500,
      rewindSpeed: 1000,
      breakpoints: {
        1024: {
          destroy: true,
        }
      }
    });

    this.benefitsCarousel.mount();
    this.scrollObserver(benefitElement);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && context.benefitsCarousel) {
        // refresh carousel each time when it is intersecting in viewport, to prevent it from not being initialized properly (for example when page is not loaded starting from the top).
        context.benefitsCarousel.refresh();
      }
    });
  }
}

export default BenefitsBar;
